export default defineNuxtPlugin(() => {
  const script = document.createElement('script')
  script.src = 'https://static.zdassets.com/ekr/snippet.js?key=01486973-4efb-443b-ac24-5712af33bbe3'
  script.id = 'ze-snippet'
  script.async = true
  script.defer = true
  document.body.appendChild(script)
})
